exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-1d7a62ba]{width:800px;justify-content:center;display:block;margin:auto}@media screen and (max-width:600px){.avatar[data-v-1d7a62ba]{width:300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d7a62ba","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Avatar.vue
// module id = 484
// module chunks = 0